<template>
  <mu-card id="my-questions">
    <mu-card-header
      titleClass="blueTitle largeTitle"
      title="My questions"
      subTitle="Your recent questions">
    </mu-card-header>
    <mu-list>
      <div v-if="isLoading">
        <mu-list-item

          v-for="item, index in dummyLoaders"
          :key="'dl-'+ index"
          :title="item.display_name"
        >
          <mu-linear-progress slot="describe" color="#d9d9d9"
                              style="width: 50%; height: 12px;background: rgb(214, 214, 214); margin-bottom: 8px"></mu-linear-progress>
          <mu-linear-progress slot="describe" color="#d9d9d9"
                              style="width: 16%; height: 12px;background: rgb(214, 214, 214); margin-bottom: 8px"></mu-linear-progress>
        </mu-list-item>
      </div>
      <div v-if="!isLoading">


        <div>
          <mu-content-block>
            No questions added yet
          </mu-content-block>
        </div>

        <mu-list-item
          v-for="item, index in data"
          :key="'q-' + index"
          :title="item.question"
          v-once
        >
          <mu-avatar
            :src="item.profile_large"
            v-once
            slot="left"
            color="white"
            backgroundColor="#E9E9E8"
          >
          </mu-avatar>
        </mu-list-item>
      </div>
    </mu-list>
    <mu-card-actions align="left">
      <mu-raised-button v-if="data.length > 0" label="See all" fullWidth></mu-raised-button>
    </mu-card-actions>
  </mu-card>
</template>
<script>
  import DiscussionApi from '../../../api/Discussion';


  export default {
    name: "my-questions",
    props: {
      userId: {
        type: Number,
        default: 0
      }
    },
    watch: {
      'userId': function () {
        let self = this;
        DiscussionApi.getDiscusionRecentlyAsked(self.userId)
          .then(function (response) {
            self.data = response.data;
            self.isLoading = false;
          })
          .catch(function (error) {
            self.data = [];
            self.isLoading = false;
          })
      }
    },
    data () {
      return {
        isLoading: true,
        dummyLoaders: [{}, {}, {}, {}],
        isSaving: false,
        data: []
      }
    },
    mounted(){
      let self = this;
      DiscussionApi.getDiscusionRecentlyAsked(self.userId)
        .then(function (response) {
          self.data = response.data;
          self.isLoading = false;
        })
        .catch(function (error) {
          self.data = [];
          self.isLoading = false;
        })
    },
    methods: {
      askQuestion(){
        let self = this;
        self.$router.push({
          name: 'Ask a question'
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// MyQuestions.vue?eaafe0e0